import React from "react";
import CompanyService from "../../SuperAdmin/modules/CompanyService";


export function CompanyServicePage() {

    return <CompanyService />;
}
